/** Null on /login: its own /me probe fails refresh when the session is dead — redirecting would loop. */
export function getAuthFailureRedirectUrl(location: { pathname: string; search: string }): string | null {
	if (location.pathname === '/login') {
		return null
	}

	const currentUrl = `${location.pathname}${location.search}`
	if (currentUrl === '/') {
		return '/login'
	}

	return `/login?redirect=${encodeURIComponent(currentUrl)}`
}

export function getSafeRedirectUrl(redirect: string | undefined): string {
	if (!redirect) {
		return '/'
	}

	// Only allow relative paths — block protocol-relative URLs and absolute URLs
	if (!redirect.startsWith('/') || redirect.startsWith('//')) {
		return '/'
	}

	return redirect
}
